import React, { useEffect, useState, useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import UnauthorizedNavbar from "./unauthorizedNavbar";
import UnauthorizedFooter from "./unauthorizedFooter";
import '../homepage.css';
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { fetchAllExploreData } from "./services/exploreDataService";
import GetInTouchButton from "./GetInTouchButton";

const CustomPrevArrow = ({ onClick }) => (
  <button className="custom-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </button>
);

const CustomNextArrow = ({ onClick }) => (
  <button className="custom-arrow next" onClick={onClick}>
    <FaChevronRight />
  </button>
);
const UnauthorizedHomePage = () => {
  const [show, setShow] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [users, setUsers] = useState(0);
  const [strategies, setStrategies] = useState(0);
  const [cagr, setCagr] = useState(0);
  const [blogs, setBlogs] = useState([]);
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [likes, setLikes] = useState({});
  const [openIndex, setOpenIndex] = useState(null);
 const [allVideos, setAllVideos] = useState([]);
 const [faqs, setFaqs] = useState([]);
 const videoSliderRef = useRef(null);
   const [showPopup, setShowPopup] = useState(false);



  const testimonials = [
    { text: "Best backtesting app for Indian stocks. Data is super accurate.", author: "Sarang Mashale" },
    { text: "Finally a no-code tool that works. Strategy builder is smooth.", author: "Pratik Dige" },
    { text: "Smooth UI and very fast backtesting. Best stock analysis tool.", author: "Abhishek Salape" },
    { text: "Easiest way to verify strategies. No coding needed on this app.", author: "Shivam Salunkhe" },
    { text: "10 years of data makes this the best backtesting app in India.", author: "Sachin Chalgeri" },
    { text: "Simple interface but powerful stock backtesting engine inside", author: "Sulabha Chakradhar" },
    { text: "Testing swing strategies is effortless. Best stock market app", author: "Akash Gavit" }
  ];

  // ✅ Fetch blogs/newsletters
  useEffect(() => {
    fetch(`${BASE_URL}/fetchNewsLetterAndBlogs`)
      .then((response) => response.json())
      .then((data) => {
        console.log("API Data:", data); // debug
        if (Array.isArray(data)) {
          const filtered = data.filter((item) => item.status === 1);
          const sortedData = filtered.sort(
            (a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)
          );
          setBlogs(sortedData);

          // initialize likes
          const initialLikes = sortedData.reduce((acc, news) => {
            acc[news.id] = news.likesCount || 0;
            return acc;
          }, {});
          setLikes(initialLikes);
        } else {
          console.error("Unexpected API response", data);
          setBlogs([]);
        }
      })
      .catch((err) => console.error("Error fetching blogs:", err));
  }, [BASE_URL]);


  const handleRedirect = (news) => {
    const newState = {
      text: news.text || "Untitled",
      backgroundImage: news.backgroundImage,
      publishedDate: news.publishedDate,
      likesCount: likes[news.id] || 0,
      id: news.id,
      htmlPageLink: news.htmlPageLink,
    };
    setTimeout(() => {
             const fileName = news.htmlPageLink
                   ?.split("/")
                   ?.pop()
                   ?.replace(".html", "");

        navigate(`/blogs/${fileName}`, { state: newState });

        }, 100);
  };


const settings = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 3,   // ✅ show 4 cards
  slidesToScroll: 1,
  arrows: true,
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 3 } }, // for laptops
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 }
    }
  ],
};

  useEffect(() => {
    animateCount(setUsers, 8000, 20);
    animateCount(setStrategies, 15000, 20);
    animateCount(setCagr, 48, 40);
  }, []);

  const animateCount = (setter, target, delay) => {
    let count = 0;
    const step = () => {
      count += Math.ceil(target / 100);
      if (count >= target) {
        setter(target);
      } else {
        setter(count);
        setTimeout(step, delay);
      }
    };
    step();
  };

  const portfolios = [
  {
    id: 1,
    title: "Quant Momentum",
    description:
      "Active momentum-driven India portfolio.",
    img: "https://bossinvestor.in/backgroundimages/quantMomentum.jpg",
    tags: ["Momentum Strategy"],
    tagClasses: ["tag-yellow"],
  },
  {
    id: 2,
    title: "Quant Compounding",
    description:
      "Steady India portfolio for long-term growth.",
    img: "https://bossinvestor.in/backgroundimages/quantCompounding.jpg",
    tags: ["GARP Strategy"],
    tagClasses: ["tag-purple"],
  },
  {
    id: 3,
    title: "Focus360 Velocity",
    description:
      "Premium India, US and Gold Strategy",
    img: "https://bossinvestor.in/backgroundimages/Focus360.jpg",
    tags: ["Hero Strategy"],
    tagClasses: ["tag-orange"],
  },
  {
    id: 4,
    title: "Focus360 Ascend",
    description:
      "Premium low-volatility global compounding.",
    img: "https://bossinvestor.in/backgroundimages/focus360Ascend.jpg",
    tags: ["Lowest Drawdown"],
    tagClasses: ["tag-green"],
  },
];

useEffect(() => {
   fetch(`${BASE_URL}/fetchActiveQueAns`)
    .then((res) => res.json())
    .then((response) => {
      if (response?.data) {
        const homepageFaqs = response.data.filter(
          (item) => item.section === "homepage"
        );

        setFaqs(homepageFaqs);
      }
    })
    .catch((err) => console.error("FAQ Fetch Error:", err));
}, []);



  const videoSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };


  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchAllExploreData();
         const list = response.data || [];
      setAllVideos(list);
      } catch (error) {
        console.error("Failed to fetch explore data.");
      }
    };
    fetchData();
  }, []);

    const handleSubscribe = (store) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      if (store === "android") {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.bossinvestor.app";
      } else if (store === "ios") {
        window.location.href =
          "https://apps.apple.com/us/app/example-app/id123456789"; // replace with real ID
      }
    } else {
      setShowPopup(true);
    }
  };

  const getYouTubeId = (url) => {
  const regExp = /(?:youtube\.com.*(?:\\?|&)v=|youtu\.be\/)([^&#]*)/;
  const match = url.match(regExp);
  return match && match[1] ? match[1] : null;
};


  return (
    <>
      <UnauthorizedNavbar />
      <div>
        <div className="header-block">
          <header className="homepage-header  text-center">
          <h1 className="homepage-title animate-fade-in-up">
            Your Edge in the Market 
            <br></br>
            <span className="text-dark-gradient fw-bold">Data-Driven Swing Trading & Research</span>
          </h1>
          <h2 className="homepage-subtitle animate-fade-in-up animate-delay-1">
            BossInvestor replaces guesswork with precision. Use our Stock Backtesting Tool and Model Portfolios to find winning strategies in the Indian stock market.
          </h2>

          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 animate-fade-in-up animate-delay-2">
            <a href="/model-portfolio" className="btn-primary text-decoration-none">
              Explore Portfolios
            </a>
            <a href="#backtester-tool" className="btn-secondary text-decoration-none">
              Try Backtester
            </a>
          </div>
          </header>
        </div>
        
        <section className="why-section py-5 px-3 px-md-5 bg-white shadow-inner">
          <div className="container text-center">
            <h2 className="why-title fw-bold mb-3">
              Why Choose BossInvestor?
            </h2>
            <div className="row g-4">
              {/* Card 1 */}
              <div className="col-12 col-md-4 why-card-box">
                <div className="why-card bg-white p-5 rounded-4 shadow-lg h-100 hover-effect">
                  <div className="why-icon mb-3">
                    <i className="fas fa-robot"></i>
                  </div>
                  <h3 className="why-card-title fw-semibold mb-3 text-dark">
                    Instant Strategy Backtesting
                  </h3>
                  <p className="why-card-text text-muted">
                    Your personal research lab. Test your theories with our powerful backtesting platform—no coding or spreadsheets required.
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="col-12 col-md-4">
                <div className="why-card bg-white p-5 rounded-4 shadow-lg h-100 hover-effect">
                  <div className="why-icon mb-3">
                    <i className="fas fa-chart-line"></i>
                  </div>
                  <h3 className="why-card-title fw-semibold mb-3 text-dark">
                     Stress-Free Model Portfolios
                  </h3>
                  <p className="why-card-text text-muted">
                    Achieve stability and growth. Choose from diverse investment portfolios tailored to your risk profile, from aggressive growth to balanced stability.
                  </p>
                </div>
              </div>

              {/* Card 3 */}
              <div className="col-12 col-md-4">
                <div className="why-card bg-white p-5 rounded-4 shadow-lg h-100 hover-effect">
                  <div className="why-icon mb-3">
                    <i className="fas fa-bullseye"></i>
                  </div>
                  <h3 className="why-card-title fw-semibold mb-3 text-dark">
                    Data-Backed Stock Ideas
                  </h3>
                  <p className="why-card-text text-muted">
                    Eliminate emotional bias. We scan thousands of stocks daily to deliver actionable swing trading and breakout stocks with clear entry and exit levels.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="model-portfolios" className="model-section">
          <div className="container text-center">
            <h2 className="section-title">
              Explore Our Model Portfolios
            </h2>
            <div className="row g-4">
              {portfolios.map((p) => (
                <div key={p.id} className="col-12 col-md-6 col-lg-3">
                  <div className="portfolio-card" onClick={() => navigate('/model-portfolio')}>
                    {/* Top Gradient Line */}
                    <div className="top-gradient"></div>

                    {/* Content */}
                    <div className="card-content">
                      {/* Logo */}
                      <div className="logo-wrapper">
                        <img src={p.img} alt={p.title} className="logo-img" />
                      </div>

                      {/* Title */}
                      <h3 className="explore-card-title">{p.title}</h3>

                      {/* Description */}
                      <p className="card-desc">{p.description}</p>

                      {/* Tags */}
                      <div className="tags">
                        {p.tags.map((tag, i) => (
                          <span key={i} className={`tag ${p.tagClasses[i]}`}>
                            {tag}
                          </span>
                        ))}
                      </div>

                      {/* Button */}
                      <div >
                        <button 
                        className="explore-btn"
                        href="/model-portfolio"
                      >
                        Explore
                      </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="etf-strategy" className="etf-section">
          <div className="container">
            <h2 className="title">
              <span >Claim Your Free Backtesting Template</span>
              <span className="text-dark-gradient fw-bold">App Exclusive</span>
            </h2>

            <p className="subtitle">
             Don't start from scratch. Download the app to unlock a pre-configured, high-performance swing trading strategy template. Rerun and trade in seconds.
            </p>

            <div className="btn-group">
              <a  onClick={() => handleSubscribe("android")} target="_blank">
                <i className="fab fa-google-play"></i> Google Play
              </a>

              <a  onClick={() => handleSubscribe("ios")} target="_blank">
                <i className="fab fa-apple"></i> App Store
              </a>
            </div>
          </div>
        </section>

        <section id="backtester-tool" className="backtester-section">
          <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-4">
            {/* Left: Video */}
            <div className="col-md-6 order-1 order-md-0">
              <div className="video-wrapper w-100">
                <video autoPlay muted loop playsInline className="w-100">
                  <source src="/unauthHomeAnimatedVideo.mp4" type="video/mp4" />
                </video>
              </div>
            </div>
            {/* Right: Text Content */}
            <div className="col-md-6 text-center text-md-start">
              <h2 className="backtester-title">
                India’s Smarter Backtesting App
              </h2>
              <p className="backtester-subheading">
                The only stock market app that lets you simulate strategies on the go. 
                From Swing trading to long-term model portfolios, let data dictate your next move.
              </p>
              {/* QR + Text in Same Line */}
              <div className="d-flex align-items-center gap-3 mt-4">
                <img 
                  src="/playstoreScanner.jpeg" 
                  alt="QR Code" 
                  style={{ width: "80px", height: "80px", borderRadius: "12px" }}
                />
                <p className="backtest-desc m-0">
                  Scan to Start Backtesting <br /> Grab your edge in the market now.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="explore-section py-16 px-6 md:px-12 bg-white shadow-inner">
          <div className="container px-3 md:px-6" style={{ minHeight: "100%" }}>
            <section className="text-center py-4">
              <h3
                className="text-decoration-none"
                style={{ fontSize: "30px", lineHeight: "38px", fontSize: '2.25rem',
                lineHeight: '2.5rem', fontWeight: '700'}}
              >
                See BossInvestor In Action
                 </h3>
              <p class="homepage-subtitle">Build smarter stock strategies in minutes, now with a step-by-step guide video to help you every step of the way.
             </p>
            </section>
            {allVideos.length === 0 ? (
              <p className="text-center text-muted">No videos available.</p>
            ) : (
              <>
              <Slider ref={videoSliderRef} {...videoSettings}>
                {allVideos.map((item, index) => {
                  const videoId = getYouTubeId(item.videoLink);
                  return (
                    <div key={index} className="px-1">
                      <div className="video-card">
                        {videoId ? (
                          <iframe
                            width="100%"
                            height="180"
                            src={`https://www.youtube.com/embed/${videoId}`}
                            title={`Video ${index}`}
                            frameBorder="0"
                            allowFullScreen
                            className="rounded"
                          ></iframe>
                        ) : (
                          <p className="text-white">Invalid video</p>
                        )}
                      </div>
                    </div>
                  );
                })}
              </Slider>
              <div className="explore-extra-nav">
              <button
                className="extra-nav-btn"
                onClick={() => videoSliderRef.current?.slickPrev()}
              >
                Prev
              </button>

              <button
                className="extra-nav-btn"
                onClick={() => videoSliderRef.current?.slickNext()}
              >
                Next
              </button>
            </div>
              </>
            )}
          </div>
        </section>

        <section id="live-counters" className="live-counters-section" >
          <h2 className="section-title">Our Achievements</h2>
          <Container>
             <Row className="justify-content-center gx-5 gy-4" >
              <Col xs={12} sm={6} md={3}>
                <div className="counter-card">
                  <h3 className="counter-value">NA+</h3>
                  <p className="counter-label">Active Users</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3}>
                <div className="counter-card">
                  <h3 className="counter-value">
                    <span id="strategiesCount">5</span>+
                  </h3>
                  <p className="counter-label">Proven Investing Factors</p>
                </div>
              </Col>
              <Col xs={12} sm={6} md={3}>
                <div className="counter-card">
                  <h3 className="counter-value">
                    <span id="cagrCount">15,000</span>+
                  </h3>
                  <p className="counter-label">Strategies Backtested</p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="blogs-section py-5">
          <div className="container">
            <h1 className="blogs-title text-center fw-bold ">
              Our Latest  &nbsp;
              <span style={
                {color: 'rgb(79 70 229 / var(--tw-text-opacity, 1))'}
              }>Newsletters & Blogs</span>
            </h1>
            {blogs.length === 0 ? (
              <p className="text-center text-muted">No blogs available.</p>
            ) : (
              <Slider {...settings}>
                {blogs.map((news) => (
                  <div key={news.id} className="px-1">
                    <div className="blog-card  h-100 overflow-hidden">
                      {/* Image */}
                      <a onClick={() => handleRedirect(news)}>
                        <img
                          src={
                            news.backgroundImage ||
                            "https://via.placeholder.com/400x200?text=No+Image"
                          }
                          alt={news.text || "Untitled Blog"}
                          className="blog-img w-100"
                        />
                      </a>
                      {/* Content */}
                      <div className="p-3">
                        <p className="category-text">
                          {news.categories || "Uncategorized"}
                        </p>
                        <h5 className="fw-bold" style={{fontSize: '15px',
                          lineHeight: '1.2',
                          fontWeight: 'bold',
                           height: '40px',
                          textDecoration: 'none',
                          color: '#000'}}>
                          {news.text || "Untitled Blog"}
                        </h5>
                        <p href="#" onClick={() => handleRedirect(news)}
                              className="blog-description">
                              {news.description}
                      </p>
                        <div className="date-text">
                          PUBLISHED: {news.publishedDate
                            ? new Date(news.publishedDate).toDateString().toUpperCase()
                            : "No Date"}
                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-2">
                          {/* Read More */}
                            <a
                              href="#"
                              className="read-more-link"
                               onClick={() => handleRedirect(news)}
                            >
                              Read More
                              <svg
                                className="read-more-icon"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                                />
                              </svg>
                            </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </section>

        <section className="testimonials-section">
          <h2 className="section-title text-center">What Our Clients Say</h2>
          <div className="slider-wrapper">
            <div className="slider-track">
              {[...testimonials, ...testimonials].map((t, index) => (
                <div key={index} className="testimonial-card">
                  <p className="testimonial-text">"{t.text}"</p>
                  <p className="testimonial-author">– {t.author}</p>
                </div>
              ))}
            </div>
          </div>
        </section> 

        <section className="faq-section">
          <div className="container">
            <h2 className="faq-title">Frequently Asked Questions</h2>
              <div className="faq-list">
                {faqs.map((faq, index) => (
                  <div key={faq.id} className="faq-item">
                    <button
                      className="faq-question"
                      onClick={() => toggleFaq(index)}
                    >
                      <span>{faq.question}</span>
                      <svg
                        className={`faq-icon ${openIndex === index ? "open" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        ></path>
                      </svg>
                    </button>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                ))}
              </div>
          </div>
        </section>
        </div>
        {showPopup && (
        <div className="qr-overlay" onClick={() => setShowPopup(false)}>
          
          <div className="qr-modal" onClick={(e) => e.stopPropagation()}>

            <button className="qr-close-icon" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <h2 className="qr-title">Get the Bossinvestor App</h2>
            <img 
              src="/playstoreScanner.jpeg" 
              alt="QR Code" 
              style={{ width: "170px", height: "170px", borderRadius: "12px" }}
            />
            <p className="qr-subtitle">
              Scan the QR code to download the app
            </p>

          </div>
        </div>
      )}

       <GetInTouchButton />
      <UnauthorizedFooter />
    </>
  );
};

export default UnauthorizedHomePage;
